module.exports = "mutation ($data: WebhookInput!) {\n  WebhookCreate(data: $data) {\n    id\n  }\n}\n"